/**
 * CLICKAR.BIZ INTERNATIONAL REST API
 * APIs Clickar.biz international.
 *
 * OpenAPI spec version: API V1
 * Contact: blureply@reply.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { environment } from '@app/../environments/environment';
import { HeaderKey } from '@shared/clickar-constants';
import { DealerInternalReferenceDTO, DealerReferenceDTO } from '@shared/model/dealer.model';
import { SellerDTO } from '@shared/model/seller.model';
import {
	ChangePasswordDTO,
	IbanDTO,
	PasswordRecovery,
	UserDTO,
	UserSignUpDTO,
	VerifyPasswordRecoveryDTO
} from '@shared/model/user.model';
import { Configuration } from '@shared/services/utils/configuration';
import { CustomHttpUrlEncodingCodec } from '@shared/services/utils/encoder';
import { Observable } from 'rxjs';

@Injectable()
export class UserApiService {
	protected basePath = 'https://localhost:8088';
	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();
	readonly encoderParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

	constructor(
		protected httpClient: HttpClient,
		@Optional() configuration: Configuration
	) {
		this.basePath = environment.baseApiUrl;

		if (configuration) {
			this.configuration = configuration;
			this.basePath = environment.baseApiUrl || configuration.basePath || this.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains 'multipart/form-data', false: otherwise
	 */
	/* private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	} */

	/**
	 * createUser
	 *
	 * @param referenceId referenceId
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	createUserUsingPOST(referenceId: DealerInternalReferenceDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
	createUserUsingPOST(referenceId: DealerInternalReferenceDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	createUserUsingPOST(referenceId: DealerInternalReferenceDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	createUserUsingPOST(referenceId: DealerInternalReferenceDTO, observe: any = 'body', reportProgress = false): Observable<any> {

		if (referenceId === null || referenceId === undefined) {
			throw new Error('Required parameter referenceId was null or undefined when calling createUserUsingPOST.');
		}

		let headers = this.defaultHeaders;
		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		const consumes: string[] = ['application/json'],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/user`,
			referenceId,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}


	/**
	 * getReferenceDealer
	 *
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getReferenceSellerDealerUsingGET(observe?: 'body', reportProgress?: boolean): Observable<SellerDTO>;
	getReferenceSellerDealerUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SellerDTO>>;
	getReferenceSellerDealerUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SellerDTO>>;
	getReferenceSellerDealerUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders;


		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<SellerDTO>(`${this.basePath}/api/v1/secure/reference-seller-dealer`,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * editUser
	 *
	 * @param userDTO userDTO
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	editUserUsingPUT(userDTO: UserDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
	editUserUsingPUT(userDTO: UserDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	editUserUsingPUT(userDTO: UserDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	editUserUsingPUT(userDTO: UserDTO, observe: any = 'body', reportProgress = false): Observable<any> {

		if (userDTO === null || userDTO === undefined) {
			throw new Error('Required parameter userDTO was null or undefined when calling editUserUsingPUT.');
		}

		let headers = this.defaultHeaders;


		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		const consumes: string[] = ['application/json'],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.put<any>(`${this.basePath}/api/v1/secure/user`,
			userDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * editUser
	 *
	 * @param iban ibanDTO
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	editIBANUsingPUT(iban: IbanDTO, observe: any = 'body', reportProgress = false): Observable<any> {

		if (iban === null || iban === undefined) {
			throw new Error('Required parameter userDTO was null or undefined when calling editUserUsingPUT.');
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		const consumes: string[] = ['application/json'],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.put<any>(`${this.basePath}/api/v1/secure/user/iban`,
			iban,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * changePassword
	 *
	 * @param changePasswordDTO changePasswordDTO
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	changePasswordUsingPOST(changePasswordDTO: ChangePasswordDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
	changePasswordUsingPOST(changePasswordDTO: ChangePasswordDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	changePasswordUsingPOST(changePasswordDTO: ChangePasswordDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	changePasswordUsingPOST(changePasswordDTO: ChangePasswordDTO, observe: any = 'body', reportProgress = false): Observable<any> {

		if (changePasswordDTO === null || changePasswordDTO === undefined) {
			throw new Error('Required parameter changePasswordDTO was null or undefined when calling changePasswordUsingPOST.');
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		const consumes: string[] = ['application/json'],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/change-password`,
			changePasswordDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * passwordRecovery
	 *
	 * @param pwdRecovery pwdRecovery
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	passwordRecoveryUsingPOST(pwdRecovery: PasswordRecovery, observe?: 'body', reportProgress?: boolean): Observable<any>;
	passwordRecoveryUsingPOST(pwdRecovery: PasswordRecovery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	passwordRecoveryUsingPOST(pwdRecovery: PasswordRecovery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	passwordRecoveryUsingPOST(pwdRecovery: PasswordRecovery, observe: any = 'body', reportProgress = false): Observable<any> {

		if (pwdRecovery === null || pwdRecovery === undefined) {
			throw new Error('Required parameter pwdRecovery was null or undefined when calling passwordRecoveryUsingPOST.');
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);

		const consumes: string[] = ['application/json'],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected)
				.set('Accept', httpHeaderAcceptSelected)
				.set(HeaderKey.NO_SUCCESS_POPUP, 'true');
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/open/pwd-recovery`,
			pwdRecovery,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * verifyPasswordRecovery
	 *
	 * @param verifyPasswordRecoveryDTO verifyPasswordRecoveryDTO
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	verifyPasswordRecoveryUsingPOST(verifyPasswordRecoveryDTO: VerifyPasswordRecoveryDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
	verifyPasswordRecoveryUsingPOST(verifyPasswordRecoveryDTO: VerifyPasswordRecoveryDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	verifyPasswordRecoveryUsingPOST(verifyPasswordRecoveryDTO: VerifyPasswordRecoveryDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	verifyPasswordRecoveryUsingPOST(verifyPasswordRecoveryDTO: VerifyPasswordRecoveryDTO, observe: any = 'body', reportProgress = false): Observable<any> {

		if (verifyPasswordRecoveryDTO === null || verifyPasswordRecoveryDTO === undefined) {
			throw new Error('Required parameter verifyPasswordRecoveryDTO was null or undefined when calling verifyPasswordRecoveryUsingPOST.');
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		const consumes: string[] = ['application/json'],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/open/verify-pwd-recovery`,
			verifyPasswordRecoveryDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * isValidCF
	 *
	 * @param birthDate
	 * @param cf
	 * @param name
	 * @param surname
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	isValidCFUsingGET(birthDate?: number, cf?: string, name?: string, surname?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
	isValidCFUsingGET(birthDate?: number, cf?: string, name?: string, surname?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
	isValidCFUsingGET(birthDate?: number, cf?: string, name?: string, surname?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
	isValidCFUsingGET(birthDate?: number, cf?: string, name?: string, surname?: string, observe: any = 'body', reportProgress = false): Observable<any> {
		let queryParameters = this.encoderParameters;
		if (birthDate !== undefined && birthDate !== null) {
			queryParameters = queryParameters.set('birthDate', <any>birthDate);
		}
		if (cf !== undefined && cf !== null) {
			queryParameters = queryParameters.set('cf', <any>cf);
		}
		if (name !== undefined && name !== null) {
			queryParameters = queryParameters.set('name', <any>name);
		}
		if (surname !== undefined && surname !== null) {
			queryParameters = queryParameters.set('surname', <any>surname);
		}

		let headers = this.defaultHeaders;


		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<boolean>(`${this.basePath}/api/v1/open/check-cf`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * registerUser
	 *
	 * @param userSignUpDTO userSignUpDTO
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	registerUserUsingPOST(userSignUpDTO: UserSignUpDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
	registerUserUsingPOST(userSignUpDTO: UserSignUpDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	registerUserUsingPOST(userSignUpDTO: UserSignUpDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	registerUserUsingPOST(userSignUpDTO: UserSignUpDTO, observe: any = 'body', reportProgress = false): Observable<any> {

		if (userSignUpDTO === null || userSignUpDTO === undefined) {
			throw new Error('Required parameter userSignUpDTO was null or undefined when calling registerUserUsingPOST.');
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		const consumes: string[] = ['application/json'],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/open/user-sign-up`,
			userSignUpDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * verifyNewUserTag
	 *
	 * @param email email
	 * @param tag tag
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	verifyNewUserTagUsingGET(email: string, tag: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	verifyNewUserTagUsingGET(email: string, tag: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	verifyNewUserTagUsingGET(email: string, tag: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	verifyNewUserTagUsingGET(email: string, tag: string, observe: any = 'body', reportProgress = false): Observable<any> {

		if (email === null || email === undefined) {
			throw new Error('Required parameter email was null or undefined when calling verifyNewUserTagUsingGET.');
		}

		if (tag === null || tag === undefined) {
			throw new Error('Required parameter tag was null or undefined when calling verifyNewUserTagUsingGET.');
		}

		let queryParameters = this.encoderParameters;
		if (email !== undefined && email !== null) {
			queryParameters = queryParameters.set('email', <any>email);
		}
		if (tag !== undefined && tag !== null) {
			queryParameters = queryParameters.set('tag', <any>tag);
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/open/verify-tag`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getUserByIdDealer
	 *
	 * @param idDealer idDealer
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getUserByIdDealerUsingGET(idDealer: number, observe?: 'body', reportProgress?: boolean): Observable<UserDTO[]>;
	getUserByIdDealerUsingGET(idDealer: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO[]>>;
	getUserByIdDealerUsingGET(idDealer: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO[]>>;
	getUserByIdDealerUsingGET(idDealer: number, observe: any = 'body', reportProgress = false): Observable<any> {
		if (idDealer === null || idDealer === undefined) {
			throw new Error('Required parameter idDealer was null or undefined when calling getUserByIdDealerUsingGET.');
		}

		let queryParameters = this.encoderParameters;
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set('idDealer', <any>idDealer);
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<UserDTO[]>(`${this.basePath}/api/v1/secure/users-dealer`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getReferenceDealer
	 *
	 * @param idDealer
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getReferenceDealerUsingGET(idDealer?: number, observe?: 'body', reportProgress?: boolean): Observable<DealerReferenceDTO>;
	getReferenceDealerUsingGET(idDealer?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DealerReferenceDTO>>;
	getReferenceDealerUsingGET(idDealer?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DealerReferenceDTO>>;
	getReferenceDealerUsingGET(idDealer?: number, observe: any = 'body', reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders;
		let queryParameters = this.encoderParameters;
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set('idDealer', <any>idDealer);
		}

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<DealerReferenceDTO>(`${this.basePath}/api/v1/secure/reference-dealer`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getReferenceDealer
	 *
	 * @param idPurchase
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getLink(idPurchase?: number, observe: any = 'body', reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders,
			queryParameters = this.encoderParameters;
		if (idPurchase !== undefined && idPurchase !== null) {
			queryParameters = queryParameters.set('idPurchase', <any>idPurchase);
		}

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/secure/user/payByLink`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	* getUser
	*
	* @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	* @param reportProgress flag to report request and response progress.
	*/
	getUserUsingGET(observe?: 'body', reportProgress?: boolean): Observable<UserDTO>;
	getUserUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO>>;
	getUserUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO>>;
	getUserUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<UserDTO>(`${this.basePath}/api/v1/secure/user`,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * isLoggedIn
	 *
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	isLoggedInUsingGET(observe?: 'body', reportProgress?: boolean): Observable<UserDTO>;
	isLoggedInUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDTO>>;
	isLoggedInUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDTO>>;
	isLoggedInUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected)
				.set(HeaderKey.NO_POPUP, 'true');
		}

		return this.httpClient.get<UserDTO>(`${this.basePath}/api/v1/secure/logged`,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * geolocation service
	 *
	 * @param email email
	 * @param tag tag
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getGeolocationUsingUsingGET(observe?: 'body', reportProgress?: boolean): Observable<any>;
	getGeolocationUsingUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	getGeolocationUsingUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	getGeolocationUsingUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ['*/*'],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/open/geolocation`,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}
}